import { Entity } from "./Entity";
import { dirMtxInverse } from "./DirMtx";
import { TILE_SIZE } from "./opts";
export class RenderableEntity extends Entity {
    constructor(width, height, baseTile) {
        super(width, height, baseTile);
        this.gone = false;
        console.log(this.trackingTiles);
        this.register();
    }
    move(dx, dy) {
        const out = super.move(dx, dy);
        this.register();
        return out;
    }
    respawn(tile) {
        super.respawn(tile);
        this.register();
    }
    render(ctx) {
    }
    kill() {
        this.gone = true;
    }
    isOnTile(tile) {
        if (this.gone)
            return false;
        for (let x = 0; x < this.trackWidth; x++) {
            for (let y = 0; y < this.trackWidth; y++) {
                if (this.trackingTiles[x][y].view.tile.id === tile.id) {
                    return true;
                }
            }
        }
        return false;
    }
    register() {
        for (let x = 0; x < this.trackWidth; x++) {
            for (let y = 0; y < this.trackWidth; y++) {
                this.trackingTiles[x][y].view.track(this);
            }
        }
    }
    renderInContext(renderer, tile) {
        const renderHistory = new Set();
        window.rh = renderHistory;
        for (let x = 0; x < this.trackWidth; x++) {
            for (let y = 0; y < this.trackWidth; y++) {
                const tracker = this.trackingTiles[x][y];
                if (tracker.view.tile === tile) {
                    const renderKey = `${tracker.view.orientation}/${tracker.pt.x - tracker.onEntityX}/${tracker.pt.y - tracker.onEntityY}`;
                    if (!renderHistory.has(renderKey)) {
                        renderHistory.add(renderKey);
                        renderer.ctx.save();
                        renderer.applyOrientation(dirMtxInverse(tracker.view.orientation));
                        renderer.ctx.translate((tracker.pt.x - tracker.onEntityX) * TILE_SIZE, (tracker.pt.y - tracker.onEntityY) * TILE_SIZE);
                        this.render(renderer.ctx);
                        renderer.ctx.restore();
                    }
                }
            }
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/RenderableEntity.ts
// module id = 7
// module chunks = 0